// Module
var code = "<div class=\"grid_division\"> <div class=\"main_grid\"> <div> <div class=\"mishion_history\"> <div class=\"mission_title\">Roles</div> </div> <div class=\"text-right\"> <a class=\"btn btn-secondary\" ui-sref=\"^.add\"> <span> <i class=\"fa fa-plus\"></i> ADD Role </span> </a> </div> <roles-main-grid authority-group=\"ctrl.authorityGroup\"> </roles-main-grid> </div> </div> </div>";
// Exports
var _module_exports = code;;
var path = 'user/pages/role/index.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;